import { useEffect } from 'react';
import { signOut } from 'aws-amplify/auth';
import pageNotFoundImage from 'assets/images/badSmile.svg';
import { RoutesPaths } from 'routes/Routes.types';
import ErrorPageView from '..';
import { TSomethingWentWrongProps } from './SomethingWentWrong.types';

const isApiError = (err: unknown): err is { status?: number } =>
  typeof err === 'object' && err !== null && 'status' in err;

const SomethingWentWrong = ({
  error,
  componentStack,
  onReset,
}: TSomethingWentWrongProps) => {
  useEffect(() => {
    if (!error) return;
    if (isApiError(error) && error.status === 401) {
      (async () => {
        await signOut();
        window.location.href = `/${RoutesPaths.LOGIN}`;
      })();
    }
  }, [error]);

  const isDev =
    process.env.NODE_ENV === 'development' && error instanceof Error;
  const description = isDev
    ? `${error.message}\n\n${componentStack || ''}`
    : 'Please try again later.';

  return (
    <ErrorPageView
      imgSrc={pageNotFoundImage}
      alt="something went wrong"
      title="OOPS! Something went wrong!"
      description={description}
      onReset={onReset}
    />
  );
};

export default SomethingWentWrong;
